/**
 * Resolve a canonical media reference to a displayable URL.
 *
 * Accepts:
 *   - `{category}/{filename}` (std/istock-653241632.jpg, kloke-valg/hodepine.png, …)
 *   - Full http(s) URL — passed through unchanged (stories, external RSS thumbnails)
 *   - Empty / undefined — returns empty string
 *
 * See signage/DESIGN.md.
 */
export function resolveAssetUrl(media: string | undefined, assetBase: string): string {
  if (!media) return '';
  if (media.startsWith('http://') || media.startsWith('https://')) return media;
  if (!assetBase) return '';
  return `${assetBase}/${media}`;
}
